// extracted by mini-css-extract-plugin
export default {"container":"PeopleFilterTypeahead_container__r808C","input":"PeopleFilterTypeahead_input__gp1Cg","dig-TextInputContainer":"PeopleFilterTypeahead_dig-TextInputContainer__nTUGv"};